import Vue from 'vue';
import VueRouter from 'vue-router'
import routes from './routes'
import store from '../store'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    linkActiveClass: 'active',
    linkExactActiveClass: 'active',
    base: '/',
    fallback: true,
    routes,
    scrollBehavior(to, from, savedPosition) {
        window.scrollTo(0, 0)
    }
})

router.beforeEach((to, from, next) => {
    if (to.name !== null) {
        const isPermitted = _.includes(to.meta.allowedUsers, store.getters.user.type)

        if (!isPermitted) {
            next({
                name: 'dashboard'
            });
        }
    }

    next()
})

export default router
